import { route, layout } from '@/lib/route-utils';
import { ROUTES } from '@/constants/routes';

export default [
  route('logout', () => import('@/routes/logout')),
  route('confirm-account', () => import('@/routes/confirm-account/index')),
  layout(
    () => import('@/components/layout/RootLayout'),
    [
      {
        path: '/',
        loader: () => {
          throw new Response('', {
            status: 302,
            headers: {
              Location: ROUTES.NSAPPS_HOME,
            },
          });
        },
      },
      layout(
        () => import('@/routes/nsapps/layout'),
        [
          {
            path: ROUTES.NSAPPS,
            loader: () => {
              throw new Response('', {
                status: 302,
                headers: {
                  Location: ROUTES.NSAPPS_HOME,
                },
              });
            },
          },
          route('nsapps/debug', () => import('@/routes/debug')),
          route('nsapps/:route/*', () => import('@/routes/nsapps/miniapp')),
        ]
      ),
      route('*', () => import('@/routes/not-found')),
    ]
  ),
];
